<template>
  <label
    class="checkbox flex justify-center items-center box-border"
    :class="{ 'checkbox--disabled': disabled }"
  >
    <input
      v-model="innerChecked"
      type="checkbox"
      class="peer hidden-checkbox focus:outline-none"
      :disabled="disabled"
      @change="onChange"
    />
    <span class="custom-checkbox peer-checked:bg-blue-primary peer-checked:border-transparent">
      <svg class="checkmark-svg" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13 1L5.35233 9.51813L1 5.29016"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
    <span v-if="label" class="checkbox-label">{{ label }}</span>
  </label>
</template>

<script setup>
import { ref, watch } from "vue"

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  label: {
    type: String,
    default: ""
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(["update:modelValue", "input"])

const innerChecked = ref(props.modelValue)

watch(
  () => props.modelValue,
  newVal => {
    innerChecked.value = newVal
  }
)

watch(innerChecked, newVal => {
  emit("update:modelValue", newVal)
})

const onChange = event => {
  emit("input", event.target.checked)
}
</script>

<style scoped>
.checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
}

.checkbox--disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.hidden-checkbox {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.custom-checkbox {
  width: 24px;
  height: 24px;
  border: 2px solid #ccc;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.hidden-checkbox:checked + .custom-checkbox::after {
  content: none;
}

.checkbox-label {
  font-size: 16px;
  user-select: none;
}

.checkmark-svg {
  width: 16px;
  height: 16px;
}
</style>
